export default {
  filterLabel: {
    dateRange: 'Intervalo de datas:',
  },
  pages: {
    compare: {
      title: 'Compare grupos nas redes sociais',
      subTitle: 'Você pode selecionar até {maxNumberOfGroups} grupos para acompanhar e comparar seu desempenho.',
      select: {
        label: 'Rede social',
        firstOption: 'Todas as redes',
      },
      button: 'Comparar',
      instructions: {
        title: 'Selecione os grupos para comparar',
        subtitle: 'Descubra oportunidades, tendências e termos para melhorar a sua estratégia.',
      },
    },
  },
};
